import React, { useState, useEffect, useContext } from "react";
import { Grid, Button, FormControl, TextField } from "@mui/material";
import "../css/ViewFBODataFilter.css";
import { MobileDatePicker } from "@mui/x-date-pickers";
import DateLocalizationProvider from "./DateLocalizationProvider";
import { DATE_FORMAT } from "../../utils/constants";
import SearchAirportDialog from "./SearchAirportDialog";
import { StorageContext } from "../../services/StorageProvider";
import SnackbarAlert from "./SnackbarAlert";

const ViewLandingFeeDataFilter = ({ onClickClear, onClickApply }) => {
  const { airportListData } = useContext(StorageContext);
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [landingDate, setLandingDate] = useState(null);
  const [originAirport, setOriginAirport] = useState(null);
  const [showSearchAirportDialog, setShowSearchAirportDialog] = useState(false);
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [snackbarKey, setSnackbarKey] = useState(0);

  useEffect(() => {
    setDefaultValue();
  }, []);

  const setDefaultValue = () => {
    setRegistrationNumber("");
    setLandingDate(null);
    setOriginAirport(null);
    setShowSearchAirportDialog(false);
    setShowErrorSnackbar(false);
  };

  const handleRegistrationNumberChange = (event) => {
    setRegistrationNumber(event.target.value);
  };

  const handleLandingDateChange = (newValue) => {
    setLandingDate(newValue);
  };

  const handleSelectAirportClick = () => {
    setShowSearchAirportDialog(true);
  };

  const handleAirportOnSelect = (airport) => {
    setOriginAirport(airport);
  };

  const handleClearFilter = () => {
    setDefaultValue();
    onClickClear();
  };

  const handleApplyFilter = () => {
    // Check if any filter is selected
    const hasFilters = registrationNumber.trim() !== "" || landingDate !== null || originAirport !== null;

    if (!hasFilters) {
      setSnackbarKey(prev => prev + 1);
      setShowErrorSnackbar(true);
      return;
    }

    onClickApply(registrationNumber, landingDate, originAirport);
  };

  const handleCloseErrorSnackbar = () => {
    setShowErrorSnackbar(false);
  };

  return (
    <>
      <div className="view-fbo-data-filter-filter-container">
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <FormControl variant="outlined">
                  <div className="view-fbo-data-filter-select-header">ARN</div>
                  <TextField
                    id="view-fbo-data-registration-number"
                    variant="outlined"
                    placeholder="Enter here"
                    className="view-fbo-data-filter-textfield"
                    value={registrationNumber}
                    onChange={handleRegistrationNumberChange}
                  />
                </FormControl>
              </Grid>
              <DateLocalizationProvider>
                <Grid item>
                  <FormControl variant="outlined">
                    <div className="view-fbo-data-filter-select-header">
                      Date of Landing
                    </div>
                    <MobileDatePicker
                      className="view-fbo-data-filter-datepicker"
                      format={DATE_FORMAT}
                      value={landingDate}
                      onChange={handleLandingDateChange}
                    />
                  </FormControl>
                </Grid>
              </DateLocalizationProvider>
              <Grid item>
                <FormControl variant="outlined">
                  <div className="view-fbo-data-filter-select-header">
                    Origin Airport
                  </div>
                  <div
                    className="view-fbo-data-filter-airport-search-container"
                    onClick={handleSelectAirportClick}
                  >
                    {originAirport?.name ? (
                      <span className="view-fbo-data-filter-airport-search-text">{originAirport?.name}</span>
                    ) : (
                      <span className="view-fbo-data-filter-airport-search-placeholder">Search</span>
                    )}
                  </div>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <div className="view-fbo-data-filter-button-container">
              <Button className="clear" onClick={handleClearFilter}>
                Clear
              </Button>
              <Button
                variant="contained"
                className="apply"
                onClick={handleApplyFilter}
              >
                Apply
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
      <SearchAirportDialog
        open={showSearchAirportDialog}
        onClose={() => setShowSearchAirportDialog(false)}
        airportData={airportListData}
        onSelectAirport={handleAirportOnSelect}
      />
      {showErrorSnackbar && (
        <SnackbarAlert 
          key={snackbarKey}
          type="error" 
          onClose={handleCloseErrorSnackbar}
        >
          Please select at least one filter before applying.
        </SnackbarAlert>
      )}
    </>
  );
};

export default ViewLandingFeeDataFilter;
